import { LANGUAGES } from '../lib/locations.js';

/**
 * Multi-select for spoken languages via a fixed dropdown list rather than free
 * text, so what a nurse stores always matches what a patient can filter on.
 * `value` is a comma-separated string (the wire format the API already uses);
 * `onChange` receives the updated comma-separated string.
 */
export default function LanguageSelect({ value, onChange, id = 'languages' }) {
  const selected = String(value || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  const toggle = (lang) => {
    const next = selected.includes(lang)
      ? selected.filter((l) => l !== lang)
      : [...selected, lang];
    onChange(next.join(','));
  };

  const add = (lang) => {
    if (lang && !selected.includes(lang)) onChange([...selected, lang].join(','));
  };

  const remaining = LANGUAGES.filter((l) => !selected.includes(l));

  return (
    <div className="lang-select">
      {selected.length > 0 && (
        <div className="chips" style={{ marginBottom: 8 }}>
          {selected.map((l) => (
            <span key={l} className="chip active" role="button" tabIndex={0} onClick={() => toggle(l)}>
              {l}
              <span className="chip-remove" aria-hidden="true">
                ×
              </span>
            </span>
          ))}
        </div>
      )}
      <select
        id={id}
        value=""
        onChange={(e) => {
          add(e.target.value);
          e.target.value = '';
        }}
        aria-label="Add a language"
        disabled={remaining.length === 0}
      >
        <option value="">
          {remaining.length === 0 ? 'All languages added' : selected.length ? 'Add another language…' : 'Select languages…'}
        </option>
        {remaining.map((l) => (
          <option key={l} value={l}>
            {l}
          </option>
        ))}
      </select>
    </div>
  );
}
